<template>
  <path
    class="seat-area-outline"
    :class="isHighlighted"
    :stroke="getStroke"
    :d="getPathString"
    @mouseenter="mouseEnter"
    @mouseleave="mouseLeave"
    v-touch:tap="selectSeatArea"
    v-touch:start="mouseEnter"
    v-touch:end="mouseLeave"
  />
</template>

<script>
export default {
  name: "seat-area-outline",
  props: {
    areaInfo: {
      required: true,
    },
    highlight: false,
    color: false,
  },
  data() {
    return {
      selected: this.highlight || false,
      hover: false,
    };
  },
  watch: {
    highlight: function () {
      this.selected = this.highlight;
    },
  },
  methods: {
    mouseEnter() {
      this.$emit("seatAreaMouseEnter", this.areaInfo);
      this.hover = true;
    },
    mouseLeave() {
      this.$emit("seatAreaMouseLeave", this.areaInfo);
      this.hover = false;
    },
    selectSeatArea() {
      this.$emit("seatAreaClick", this.areaInfo);
    },
  },
  computed: {
    isHighlighted() {
      return this.selected || this.hover ? "seat-area-outline--selected" : "";
    },
    getStroke() {
      return this.isHighlighted ? this.color : "";
    },
    getPathString() {
      let path = "";
      this.areaInfo.coordinatesList.forEach(coords => {
        path += `M ${coords[0]},${coords[1]}`;
        coords.forEach(function (cord, i) {
          if (i % 2 == 0) {
            path += `L ${cord}, ${coords[i + 1]}`;
          }
        });
        path += "z";
      })

      return path;
    },
  },
};
</script>